(() => {
  const q = (s, parent = document) => parent.querySelector(s);
  const qa = (s, parent = document) => [...parent.querySelectorAll(s)];
  const closeMenu = () => { q('.navigation')?.classList.remove('open'); const b=q('.menu-toggle'); b?.setAttribute('aria-expanded','false'); b?.setAttribute('aria-label','開啟選單'); };
  const descriptions = {
    law:'從條文到現實，拆解美國憲政如何運作。沿著制度、權利與公共生活的脈絡，讓每個重要問題都能多理解一層。',
    red:'回到文本，重讀人物、世情與傳統文化。跟著茶館的閱讀視角，慢慢走進紅樓夢裡的情感與時代。',
    history:'從制度、思想與器物出發，梳理文明的來路。把歷史串成一條長線，也為理解今天找到更清晰的座標。',
    hotpot:'把熱門話題端上桌，邊涮邊聊、追根究底。從生活切入，讓一席熱鬧的對話也有值得帶走的觀點。'
  };

  // Preserve the existing dialog button's classes and arrow markup.
  function updateWatchLink(dialog, watchUrl) {
    const link = q('a[data-program-watch]', dialog) ||
      qa('a', dialog).find(a => /探索會員計畫|前往觀看/.test(a.textContent));
    if (!link) return;
    link.setAttribute('data-program-watch', '');
    const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      node.nodeValue = node.nodeValue.replace(/探索會員計畫/g, '前往觀看');
    }
    if (!link.hasAttribute('data-watch-original-style')) {
      link.dataset.watchOriginalStyle = link.getAttribute('style') || '';
      if (link.hasAttribute('tabindex')) link.dataset.watchOriginalTabindex = link.getAttribute('tabindex');
    }
    if (watchUrl) {
      link.setAttribute('href', watchUrl);
      link.removeAttribute('aria-disabled');
      link.setAttribute('style', link.dataset.watchOriginalStyle);
      if ('watchOriginalTabindex' in link.dataset) {
        link.setAttribute('tabindex', link.dataset.watchOriginalTabindex);
      } else {
        link.removeAttribute('tabindex');
      }
    } else {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      link.style.opacity = '0.5';
      link.style.cursor = 'not-allowed';
    }
  }

  document.addEventListener('click', event => {
    const disabledWatch = event.target.closest('[data-program-watch][aria-disabled="true"]');
    if (disabledWatch) { event.preventDefault(); return; }
    const menu=event.target.closest('.menu-toggle');
    if(menu){const open=menu.getAttribute('aria-expanded')!=='true';q('.navigation')?.classList.toggle('open',open);menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?'關閉選單':'開啟選單');}
    if(event.target.closest('.navigation a')) closeMenu();
    const filter=event.target.closest('[data-shop-filter]');
    if(filter){const section=filter.closest('.shop-section'),category=filter.dataset.shopFilter;let count=0;qa('[data-shop-filter]',section).forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));qa('.shop-card',section).forEach(c=>{c.hidden=c.dataset.category!==category;if(!c.hidden)count++;});q('#shop-status',section).textContent='顯示 '+count+' 件'+filter.textContent.trim();const browse=q('#shop-browse',section);browse.href=filter.dataset.collectionUrl;browse.firstChild.textContent='瀏覽'+filter.textContent.trim()+' ';}

    const program=event.target.closest('[data-program]');
    if(program){
      const dialog=q('#program-dialog');
      if(dialog){
        const image=q('img',program);
        const title=q('strong',program)?.textContent.trim()||'';
        const dialogTitle=q('#dialog-title',dialog);
        const dialogDescription=q('#dialog-description',dialog);
        const dialogImage=q('#dialog-image',dialog);
        if(dialogTitle) dialogTitle.textContent=title;
        if(dialogDescription) dialogDescription.textContent=descriptions[program.dataset.program]||q('.program-description',program)?.textContent||'';
        if(dialogImage && image){dialogImage.src=image.currentSrc||image.src;dialogImage.alt=title+'會員節目封面';}
        updateWatchLink(dialog,program.dataset.watchUrl?.trim()||'');
        if(!dialog.open) dialog.showModal();
      }
    }

    const plan=event.target.closest('[data-plan]');
    if(plan){if(plan.dataset.planUrl){window.location.assign(plan.dataset.planUrl);return;}const card=plan.closest('.price-card')||plan.closest('.support-copy');q('#plan-title').textContent=q('h3',card)?.textContent||'主持人粉絲贊助';q('#plan-price').textContent=q('.price-amount',card)?.textContent||q('.support-prices',card)?.textContent;q('#plan-description').textContent=q('.price-note',card)?.textContent||q('.support-note',card)?.textContent;q('#plan-dialog').showModal();}
    const close=event.target.closest('.dialog-close,.close-plan');if(close)close.closest('dialog').close();
    if(event.target.tagName==='DIALOG'){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closeMenu();});
  window.matchMedia('(min-width: 961px)').addEventListener('change',closeMenu);
  document.addEventListener('shopify:section:load',closeMenu);
  document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.shop-card')||q('.shop-card',event.target);if(card){const section=card.closest('.shop-section');q('[data-shop-filter="'+card.dataset.category+'"]',section)?.click();}});
})();

/* One controller for the HTML preview and native Shopify section. */
(() => {
  const instances = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mount(root) {
    if (instances.has(root)) return;
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const pause = root.querySelector('[data-carousel-pause]');
    const current = root.querySelector('[data-carousel-current]');
    const status = root.querySelector('[data-carousel-status]');
    const abort = new AbortController();
    const on = (el, type, fn, options = {}) => el.addEventListener(type, fn, { ...options, signal: abort.signal });
    let index = 0, timer, hovered = false, visible = true;
    let stopped = root.dataset.autoplay === 'false' || motion.matches || Boolean(window.Shopify?.designMode);
    const interval = Math.max(4000, Number(root.dataset.interval) || 7000);
    function schedule() {
      clearTimeout(timer);
      if (!stopped && !hovered && visible && !document.hidden && slides.length > 1) timer = setTimeout(() => show(index + 1), interval);
    }
    function updatePause() {
      pause.setAttribute('aria-label', stopped ? '開始自動輪播' : '暫停自動輪播');
      pause.querySelector('[data-carousel-pause-icon]').textContent = stopped ? '▷' : 'Ⅱ';
      root.dataset.playing = String(!stopped);
    }
    function show(next, announce = false) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
      current.textContent = String(index + 1).padStart(2, '0');
      if (announce) status.textContent = slides[index].getAttribute('aria-label');
      schedule();
    }
    function manual(next) { stopped = true; updatePause(); show(next, true); }
    on(root.querySelector('[data-carousel-prev]'), 'click', () => manual(index - 1));
    on(root.querySelector('[data-carousel-next]'), 'click', () => manual(index + 1));
    dots.forEach((dot, i) => on(dot, 'click', () => manual(i)));
    on(pause, 'click', () => { stopped = !stopped; updatePause(); schedule(); });
    on(root, 'mouseenter', () => { hovered = true; schedule(); });
    on(root, 'mouseleave', () => { hovered = false; schedule(); });
    // Keyboard interaction stops rotation until the visitor explicitly starts it again.
    on(root, 'focusin', event => { if (event.target !== pause) { stopped = true; updatePause(); schedule(); } });
    on(root, 'keydown', event => {
      if (!event.target.closest('.hero-controls,.hero-arrow')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); manual(index + (event.key === 'ArrowLeft' ? -1 : 1)); }
    });
    let touch;
    on(root, 'touchstart', event => { const p = event.touches[0]; touch = { x: p.clientX, y: p.clientY }; }, { passive: true });
    on(root, 'touchend', event => { if (!touch) return; const p = event.changedTouches[0], dx = p.clientX - touch.x, dy = p.clientY - touch.y; touch = null; if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) manual(index + (dx < 0 ? 1 : -1)); }, { passive: true });
    on(document, 'visibilitychange', schedule);
    on(motion, 'change', () => { if (motion.matches) { stopped = true; updatePause(); schedule(); } });
    on(root, 'shopify:block:select', event => { const selected = event.target.closest('[data-slide]'); if (selected) manual(slides.indexOf(selected)); });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.15 });
    observer.observe(root);
    updatePause(); show(0);
    instances.set(root, () => { clearTimeout(timer); abort.abort(); observer.disconnect(); instances.delete(root); });
  }
  function init(scope = document) { if (scope.matches?.('[data-carousel]')) mount(scope); scope.querySelectorAll('[data-carousel]').forEach(mount); }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, destroy] of instances) if (event.target.contains(root)) destroy(); });
})();

